import React, { useState, useEffect } from "react";
import ReactHtmlParser from "react-html-parser";
import axios from "axios";
import { Select, Popover } from "antd";
import { useAppSelector } from "../../hooks";
import ButtonDefault from "../../components/ButtonDefault";
import giftUsage1 from "../../assets/images/gift-usage/jibunehon_giftcode_01.png";
import giftUsage2 from "../../assets/images/gift-usage/character-make-hair@2x.png";
import giftUsage3 from "../../assets/images/gift-usage/character-message-1@2x.png";
import giftUsage4 from "../../assets/images/gift-usage/character-confirmation@2x.png";
import giftUsage5 from "../../assets/images/gift-usage/jibunehon_giftcode_07.png";
import iconDown from "../../assets/images/arrow-book-detail/arrow-down.svg";
import { utils } from "../../utils/utils";
import { shippingFee, designNon } from "../../../configuration";
import { MethodOption } from "../../constants/methodOption";
import { routesObj } from "../../routes/routes";
import { gtm, toDataLayerItem } from "../../utils/gtm";
import SessionTitle from "../../components/SectionTitle";
import gift_usage_1 from "../../assets/images/embellishments/book-details/book_detail_01.png";
import gift_usage_2 from "../../assets/images/embellishments/book-details/book_detail_02.png";
import gift_usage_3 from "../../assets/images/embellishments/book-details/book_detail_03.png";
import gift_usage_4 from "../../assets/images/embellishments/book-details/book_detail_04.png";
import gift_usage_5 from "../../assets/images/embellishments/book-details/book_detail_05.png";
import gift_usage_6 from "../../assets/images/embellishments/book-details/book_detail_06.png";
import gift_usage_7 from "../../assets/images/embellishments/book-details/book_detail_07.png";
import gift_usage_8 from "../../assets/images/embellishments/book-details/book_detail_08.png";
import gift_usage_9 from "../../assets/images/embellishments/book-details/book_detail_09.png";
import gift_usage_10 from "../../assets/images/embellishments/book-details/book_detail_10.png";
import cart from "../../assets/images/gift-usage/cart-light.svg";
import arrow_1 from "../../assets/images/gift-usage/arrow1.svg";
import arrow_2 from "../../assets/images/gift-usage/arrow2.svg";

import "./index.scss";

const GiftUsage = () => {
  const dataPage = useAppSelector((state) => state.pageData);
  const itemsCart = useAppSelector((state) => state.cart);
  const [choosenBookId, setChoosenBookId] = useState(1);
  const [hovered, setHovered] = useState<boolean>(false);
  const [loadingGift, setLoadingGift] = useState<boolean>(false);
  const [disabled, setDisabled] = useState<boolean>(false);

  const formatter = new Intl.NumberFormat("ja-JP", {
    style: "currency",
    currency: "JPY",
  });
  const handleGiftOrder = async () => {
    setDisabled(true);
    if (JSON.parse(utils.getStorage("items"))?.selectedBook?.length > 0) {
      utils.setStorage("items", JSON.stringify(itemsCart));
    }
    if (
      JSON.parse(utils.getStorage("items"))?.selectedBook?.length > 0 &&
      itemsCart.selectedBook?.length > 0 &&
      !JSON.parse(utils.getStorage("items"))?.selectedBook[0]?.is_gift &&
      !itemsCart?.selectedBook[0]?.is_gift
    ) {
      setHovered(true);
    } else {
      // setHovered(false);
      setLoadingGift(true);
      const gift_order_info = {
        book_id: choosenBookId,
        amount: 1,
        is_gift: true,
        delivery_fee: shippingFee.price,
      };
      const formData = new FormData();
      formData.append(
        "authenticity_token",
        dataPage.data?.data?.form_authenticity_token
      );
      formData.append("item", JSON.stringify(gift_order_info));
      let response;
      try {
        response = await axios({
          method: "post",
          url: "/cart/add_gift",
          data: formData,
          headers: { "Content-Type": "multipart/form-data" },
        });
      } catch (error) {
        console.log(error);
      }
      const itemGift = {
        selectedBook: [
          {
            id: response?.data?.order_item_id || 0,
            book_id: choosenBook().id,
            image: choosenBook().images[0],
            book_name: choosenBook().name,
            price: choosenBook().price,
            amount: 1,
            is_gift: true,
            delivery_fee: shippingFee.price,
          },
        ],
        bookItems: [
          {
            index: 0,
            id: response?.data?.order_item_id || 0,
            book_id: choosenBook().id,
            image: choosenBook().images[0],
            book_name: choosenBook().name,
            price: choosenBook().price,
            amount: 1,
            is_gift: true,
            giftPackaging: {
              chooseGift: true,
              pricePackaging: designNon.price,
            },
          },
        ],
        cartTotalPrice: choosenBook().price,
        cartTotalItem: 1,
        orderAddress: {},
        orderMethod: {
          type: `${MethodOption.CREDIT.value}`,
        },
      };
      if (JSON.parse(utils.getStorage("items"))?.selectedBook) {
        let itemPreGift = JSON.parse(utils.getStorage("items"));
        itemPreGift?.selectedBook?.unshift({
          id: response?.data?.order_item_id,
          book_id: choosenBook().id,
          image: choosenBook().images[0],
          book_name: choosenBook().name,
          price: choosenBook().price,
          amount: 1,
          is_gift: true,
          delivery_fee: shippingFee.price,
        });
        itemPreGift?.bookItems?.unshift({
          index: itemsCart?.selectedBook.length,
          id: response?.data?.order_item_id,
          book_id: choosenBook().id,
          image: choosenBook().images[0],
          book_name: choosenBook().name,
          price: choosenBook().price,
          amount: 1,
          is_gift: true,
          giftPackaging: {
            chooseGift: true,
            pricePackaging: designNon.price,
          },
        });
        itemPreGift.cartTotalPrice =
          itemPreGift?.cartTotalPrice + choosenBook().price;
        itemPreGift.cartTotalItem = itemPreGift?.cartTotalItem + 1;

        utils.setStorage("items", JSON.stringify(itemPreGift));
      } else {
        utils.setStorage("items", JSON.stringify(itemGift));
      }

      if (window.fbq) {
        console.log("fbq AddToCart");
        window.fbq('track', 'AddToCart');
      }

      gtm.pushEcommerce("add_to_cart", [
        toDataLayerItem({
          book_id: choosenBook().id,
          book_name: choosenBook().name,
          price: choosenBook().price,
          amount: 1,
          is_gift: true,
        }),
      ]);

      window.location.href = `${routesObj.cart.path}`;
    }
    setDisabled(false);
    setLoadingGift(false);
  };
  const choosenBook = () => {
    return dataPage.data?.data?.books[choosenBookId - 1];
  };

  const giftUsageImg = [
    { src: gift_usage_1, alt: "gift_usage_1" },
    { src: gift_usage_2, alt: "gift_usage_2" },
    { src: gift_usage_3, alt: "gift_usage_3" },
    { src: gift_usage_4, alt: "gift_usage_4" },
    { src: gift_usage_5, alt: "gift_usage_5" },
    { src: gift_usage_6, alt: "gift_usage_6" },
    { src: gift_usage_7, alt: "gift_usage_7" },
    { src: gift_usage_8, alt: "gift_usage_8" },
    { src: gift_usage_9, alt: "gift_usage_9" },
    { src: gift_usage_10, alt: "gift_usage_10" },
  ];

  useEffect(() => {
    if (document.referrer.endsWith("/books/2")) {
      setChoosenBookId(2);
    }
  }, []);

  return (
    <>
      <div className="blue-highlight" style={{ maxWidth: "100%" }}></div>
      <div className="gift_usage" style={{ maxWidth: "100%" }}>
        {giftUsageImg.map((img, index) => (
          <div
            key={index}
            className={`embel-position book_details-${index + 1}`}
          >
            <img src={img.src} alt={img.alt} className="embel" loading="lazy" decoding="async" />
          </div>
        ))}
        <SessionTitle
          title="電子ギフト券"
          background="#00A5D9"
          color="#005582"
          subtitle={ReactHtmlParser(
            "JibunEHONを、お子さんの居る大切な方へ<br/>プレゼントできる電子ギフト券です。"
          )}
          isTitlePage
        />

        <div className="gift-usage__background">
          <div className="text_image style_border mx-10_5">
            <p style={{ width: "180px" }}>贈る絵本を選ぶ</p>
          </div>
          <div className="gift_usage-content">
            <Select
              className="book-select"
              onSelect={(value) => {
                setChoosenBookId(value);
              }}
              suffixIcon={
                <img
                  src={iconDown}
                  alt="icon_down"
                  style={{ width: "13px", height: "14px" }}
                  loading="lazy"
                  decoding="async"
                />
              }
              value={choosenBookId}
            >
              {dataPage.data?.data?.books.map((item) => {
                return (
                  <Select.Option key={item.id} value={item.id}>
                    {item.name}
                  </Select.Option>
                );
              })}
            </Select>
            <div className="price_button box-add__gift">
              <p style={{ marginTop: "-3px" }}>
                {formatter.format(choosenBook()?.price || 0)}{" "}
                <span>（消費税､送料込） </span>
              </p>
            </div>
            <Popover
              content="絵本と電子ギフト券は 同時に購入できません。"
              open={hovered}
              getPopupContainer={(trigger) => trigger.parentNode as HTMLElement}
              className="full-xl"
              onOpenChange={() => {
                if (hovered) setHovered(false);
              }}
              trigger="click"
            >
              <ButtonDefault
                classButton="full-xl"
                outline={false}
                onClick={handleGiftOrder}
                disabled={disabled}
                htmlType="button"
                loading={loadingGift}
              >
                <span style={{ width: "70%" }}>カートに入れる</span>
                <img
                  src={cart}
                  alt="cart"
                  style={{
                    width: "33px",
                    height: "25px",
                  }}
                  loading="lazy"
                  decoding="async"
                />
              </ButtonDefault>
            </Popover>
          </div>
        </div>

        <div
          className="gift-usage__background"
          style={{ position: "relative", zIndex: 1 }}
        >
          <div className="text_image style_border mx-10_5">
            <p>電子ギフト券の使い方</p>
          </div>
          <div
            className="gift_usage-subtitle"
            style={{ paddingTop: "28px", paddingBottom: "12px" }}
          >
            ギフト券を購入された方
          </div>
          <img src={arrow_1} alt="arrow_1" className="gift_usage-arrow-1" loading="lazy" decoding="async" />
          <div className="gift_usage-content">
            ギフト券を購入すると
            <br />
            メールでギフト用サイトのURLが
            <br />
            送られてきます。
            <br />
            絵本を贈りたい相手に
            <br />
            このURLを送信してください。
            <br />
          </div>
          <div
            className="gift_usage-content"
            style={{
              margin: "0 69px",
              marginTop: "30px",
              borderBottom: "solid 3px #00A5D9",
            }}
          ></div>
          <div
            className="gift_usage-subtitle"
            style={{ paddingTop: "40px", paddingBottom: "8px" }}
          >
            URLを受け取った方
          </div>
          <img src={arrow_1} alt="arrow_1" className="gift_usage-arrow-1" loading="lazy" decoding="async" />
          <div className="gift_usage-content">
            送られてきたURLを
            <br />
            クリックしてください。
          </div>
          <img src={arrow_2} alt="arrow_2" className="gift_usage-arrow-2" loading="lazy" decoding="async" />
          <div
            className="gift_usage-content"
            style={{ marginTop: "5px", marginBottom: "10px" }}
          >
            ログイン・アカウント新規作成
            <br />
            画面になるので、ログインか
            <br />
            アカウントを作成してください。
            <br />
            ログインできるとキャラクターを
            <br />
            作る画面になるので
            <br />
            名前、生年月日、性別、見た目を
            <br />
            決めてください。
          </div>
          <img
            src={giftUsage1}
            alt="giftUsage1"
            height={"277px"}
            className="gift_usage-image"
            loading="lazy"
            decoding="async"
          />
          <img
            src={giftUsage2}
            alt="giftUsage2"
            height={"277px"}
            loading="lazy"
            decoding="async"
            style={{ marginTop: "15px" }}
            className="gift_usage-image"
          />
          <div>
            <img src={arrow_2} alt="arrow_2" className="gift_usage-arrow-2" loading="lazy" decoding="async" />
          </div>
          <div className="gift_usage-content" style={{ marginBottom: "10px" }}>
            キャラクターが完成したら
            <br />
            写真※を選択し、メッセージを入力して
            <br />
            「絵本をプレビュー」をタップして
            <br />
            絵本を確認してください。
            <br />
            ※絵本によっては設定内容が変わります。
          </div>
          <img
            src={giftUsage3}
            alt="giftUsage3"
            height={"412px"}
            className="gift_usage-image"
            loading="lazy"
            decoding="async"
          />
          <div>
            <img src={arrow_2} alt="arrow_2" className="gift_usage-arrow-2" loading="lazy" decoding="async" />
          </div>
          <div className="gift_usage-content" style={{ marginBottom: "10px" }}>
            問題なければ次に進んで
            <br />
            名前や生年月日に間違いないか
            <br />
            確認してください。
          </div>
          <img
            src={giftUsage4}
            alt="giftUsage4"
            height={"412px"}
            className="gift_usage-image"
            loading="lazy"
            decoding="async"
          />
          <div>
            <img src={arrow_2} alt="arrow_2" className="gift_usage-arrow-2" loading="lazy" decoding="async" />
          </div>
          <div className="gift_usage-content" style={{ marginBottom: "10px" }}>
            間違いなければ
            <br />
            住所を入力してください。
          </div>
          <img
            src={giftUsage5}
            alt="giftUsage5"
            height={"392px"}
            className="gift_usage-image"
            loading="lazy"
            decoding="async"
          />
        </div>
      </div>
      <div className="yellow-highlight" style={{ maxWidth: "450px" }}></div>
    </>
  );
};

export default GiftUsage;
